//functions
import { setCSSVariables } from "./functions/setCSSVariables.es6";
import { ua } from "./functions/ua.es6";
import { gnav } from "./functions/gnav.es6";
import { modal } from "./functions/modal.es6";

//classess
import ScrollFunc from "./classes/scrollfunc.es6";
import Star from "./classes/star.es6";
import Movie from "./classes/movie.es6";

export default class Main {
  constructor() {
    this.scrollFunc = new ScrollFunc();
    this.movie = new Movie();
    this.init();
  }

  init() {
    this.setFuncs();
    this.setStars();
    this.ready();
  }

  ready() {
    document.body.setAttribute("data-ready", "1");
  }

  setStars() {
    const starDom = [...document.querySelectorAll(".js-star")];

    starDom.forEach((el) => {
      const star = new Star(el);
    });
  }

  setFuncs() {
    ua();
    gnav();
    modal();
    setCSSVariables();
  }
}
